import ReactDOM from "react-dom";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  InfoCircleOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import CustomSeparator from "../Common/CustomSeparator";
import Text from "./Text";
import CustomButton from "../CustomButton/CustomButton";
import useEmpresa from "../../hooks/useEmpresa";
import {
  AlertBackdrop,
  AlertContainer,
  AlertContent,
  AlertButtonContainer,
} from "./CommonStyles";
import Colors from "../../themes/Colors";
import CheckRender from "../Common/CheckRender";

const CustomAlert = ({
  type,
  title,
  message,
  subTitle,
  onConfirm,
  onCancel,
  confirmText,
  cancelText,
  aditionalInfo,
  showSecondaryButton,
  secondaryButtonLabel,
  onSecondaryButtonClick,
  maxWidth,
  children,
  closeOnBackdrop = false,
}) => {
  const empresa = useEmpresa();
  let IconComponent;

  switch (type) {
    case "success":
      IconComponent = () => (
        <CheckCircleOutlined style={{ color: empresa?.COLOR_PRINCIPAL, fontSize: 35 }} />
      );
      break;
    case "error":
      IconComponent = () => (
        <CloseCircleOutlined style={{ color: empresa?.COLOR_PRINCIPAL, fontSize: 35 }} />
      );
      break;
    case "info":
      IconComponent = () => (
        <InfoCircleOutlined style={{ color: empresa?.COLOR_PRINCIPAL, fontSize: 35 }} />
      );
      break;
    case "confirm":
      IconComponent = () => (
        <QuestionCircleOutlined style={{ color: empresa?.COLOR_PRINCIPAL, fontSize: 35 }} />
      );
      break;
    default:
      IconComponent = null;
  }

  const content = (
    <>
      <AlertBackdrop onClick={closeOnBackdrop ? onCancel || onConfirm : undefined} />
      <AlertContainer role="dialog" aria-modal="true" maxWidth={maxWidth}>
        {IconComponent && <IconComponent />}

        <CustomSeparator height={"10px"} />

        <AlertContent>
          <Text size="20px" isTittle={true} weight={"bold"} margin={"1"}>
            {title}
          </Text>


          <CheckRender allowed={subTitle}>
            <CustomSeparator height={"5px"} />
            <Text size="20px" isTittle={true} weight={"bold"} margin={"1"}>
              {subTitle}
            </Text>
            <CustomSeparator height={"5px"} />
          </CheckRender>

          <Text size="15px" margin={"0"}>
            {message}
          </Text>

          <CustomSeparator height={"5px"} />

          <CheckRender allowed={aditionalInfo}>
            <Text size="15px" margin={"0"}>
              {aditionalInfo}
            </Text>
          </CheckRender>
          {children && (
          <div style={{ width: "100%", marginTop: "10px" }}>
            {children}
          </div>
        )}
        </AlertContent>

        {(onConfirm || onCancel || showSecondaryButton) && (
          <AlertButtonContainer>
            {onConfirm && (
              <CustomButton
                label={confirmText || "De acuerdo"}
                onClick={onConfirm}
                weight={"bold"}
                hoverColor={empresa?.COLOR_PRINCIPAL}
                bgColor={Colors.white}
                textColor={empresa?.COLOR_PRINCIPAL}
                border={`1px solid ${empresa?.COLOR_PRINCIPAL}`}
              />
            )}

            {showSecondaryButton && onSecondaryButtonClick && (
              <>
                <CustomSeparator width={"10px"} />
                <CustomButton
                  label={secondaryButtonLabel || "Generar Voucher"}
                  onClick={onSecondaryButtonClick}
                  weight={"bold"}
                  hoverColor={empresa?.COLOR_SECUNDARIO}
                  bgColor={empresa?.COLOR_SECUNDARIO}
                  textColor={Colors.white}
                />
              </>
            )}

            {onCancel && (
              <>
                <CustomSeparator width={"10px"} />
                <CustomButton
                  label={cancelText || "Cancelar"}
                  onClick={onCancel}
                  weight={"bold"}
                  hoverColor={Colors.huMyHealth}
                  bgColor={Colors.white}
                  textColor={Colors.huMyHealth}
                  border={`1px solid ${Colors.huMyHealth}`}
                />
              </>
            )}
          </AlertButtonContainer>
        )}
      </AlertContainer>
    </>
  );

  return ReactDOM.createPortal(content, document.body);
};

export default CustomAlert;
